import { computed, ref } from "vue";
import type { FixturesFormRef, FixturesItem, FixturesOrderInput } from "../types";

/**
 * 資材発注登録画面の状態を扱う composable。
 */
export const useFixturesRegisterState = () => {
  const errdialog = ref(false);
  const errMessage = ref("");
  const mode = ref(0);
  const formRef = ref<FixturesFormRef>(null);
  const wordList = ref<Record<string, string>>({});
  const order_note = ref("");
  const unitItems = ref<Array<string>>([]);
  const fixturesItems = ref<(FixturesItem | null | undefined)[] | null | undefined>(
    null
  );
  const fixturesOrderInput = ref<FixturesOrderInput>([]);

  const requiredFieldLabelKeys = ["lbl_other_memo"] as const;
  const isWordListReady = computed(() => {
    if (Object.keys(wordList.value).length === 0) return false;
    return requiredFieldLabelKeys.every((key) => key in wordList.value);
  });

  return {
    errdialog,
    errMessage,
    mode,
    formRef,
    wordList,
    order_note,
    unitItems,
    fixturesItems,
    fixturesOrderInput,
    isWordListReady,
  };
};
